// app/javascript/modules/ui_utils.js
export function scrollToPane(pane) {
  if (pane && pane.parentElement) {
    pane.parentElement.scrollTo({ left: pane.offsetLeft, behavior: "smooth" });
  }
}
